var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 84,
    viewBox: "0 0 127 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8118 40.3124L63.0927 72.4962H55.2316L53.2469 48.227C52.9727 44.8735 50.5876 42.0697 47.3215 41.2612C45.1777 40.7305 42.9094 41.1294 41.0752 42.3597L37.5588 44.7183C27.4993 51.4659 14.4859 51.9334 3.96805 45.9251L2 44.8008L6.41634 42.6143L3.47211 36.0549C14.5162 41.5227 27.556 41.1416 38.2619 35.0381L41.7021 33.0769C44.1434 31.6851 46.9052 30.9531 49.7155 30.9531H50.7657C56.0516 30.9531 60.4381 35.0397 60.8118 40.3124Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1882 40.3124L63.9073 72.4962H71.7684L73.7531 48.227C74.0273 44.8735 76.4124 42.0697 79.6785 41.2612C81.8223 40.7305 84.0906 41.1294 85.9248 42.3597L89.4412 44.7183C99.5007 51.4659 112.514 51.9334 123.032 45.9251L125 44.8008L120.584 42.6143L123.528 36.0549C112.484 41.5227 99.444 41.1416 88.7381 35.0381L85.2979 33.0769C82.8566 31.6851 80.0948 30.9531 77.2845 30.9531H76.2343C70.9484 30.9531 66.5619 35.0397 66.1882 40.3124Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7446 27.6953H28.0625V39.0993H99.7446V27.6953Z",
    fill: "#BCEF3F",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8115 72.495L34.5781 39.0977H94.8563L86.8192 72.495H41.8115Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.7165,
    cy: 72.4977,
    r: 10.754,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7188 69.2383V76.5694",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3906 72.9023L61.0595 72.9023",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.364 9.53118C62.8787 8.60209 64.9057 6.6583 65.9457 4.19916C66.9856 6.6583 69.0126 8.6021 71.5273 9.53119C68.9864 10.6571 66.9789 12.7401 65.9457 15.3154C64.9124 12.7401 62.905 10.6571 60.364 9.53118Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6471 18.4245C78.9564 17.8914 80.0181 16.8726 80.6072 15.5931C81.1963 16.8726 82.258 17.8914 83.5673 18.4245C82.2456 19.0577 81.1927 20.1497 80.6072 21.4908C80.0217 20.1497 78.9688 19.0577 77.6471 18.4245Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBasket);
export default __webpack_public_path__ + "static/media/empty_basket.9dda58d5e491ec8618d0afc3ef9576bb.svg";
export { ForwardRef as ReactComponent };